// Batch Message Composer
export const OPEN_BATCH_MESSAGE_COMPOSER = 'OPEN_BATCH_MESSAGE_COMPOSER';
export const CLOSE_BATCH_MESSAGE_COMPOSER = 'CLOSE_BATCH_MESSAGE_COMPOSER';
export const SET_BATCH_MESSAGE_COMPOSER_MESSAGE = 'SET_BATCH_MESSAGE_COMPOSER_MESSAGE';

// Batch Message Report
export const OPEN_BATCH_MESSAGE_REPORT = 'OPEN_BATCH_MESSAGE_REPORT';
export const CLOSE_BATCH_MESSAGE_REPORT = 'CLOSE_BATCH_MESSAGE_REPORT';

// Batch Message Status
export const ADD_BATCH_MESSAGE_STATUS = 'ADD_BATCH_MESSAGE_STATUS';
export const UPDATE_BATCH_MESSAGE_STATUS = 'UPDATE_BATCH_MESSAGE_STATUS';
export const REMOVE_BATCH_MESSAGE_STATUS = 'REMOVE_BATCH_MESSAGE_STATUS';

// Batch Message Template
export const OPEN_BATCH_MESSAGE_TEMPLATE = 'OPEN_BATCH_MESSAGE_TEMPLATE';
export const SET_BATCH_MESSAGE_TEMPLATE = 'SET_BATCH_MESSAGE_TEMPLATE';
export const CLOSE_BATCH_MESSAGE_TEMPLATE = 'CLOSE_BATCH_MESSAGE_TEMPLATE';